var bootstrap = require("bootstrap");
import AOS from "aos";
// import { gsap } from "gsap";
// Using ESM specification
// import '/path/to/glightbox.js';
// import GLightbox from 'glightbox';
// var lightbox = GLightbox({
//   autoplayVideos: false,
// });

// gsap.fromTo(
//   "#Layer_1",
//   { opacity: 0, y: -100, scale: 0.5 },
//   { opacity: 1, y: 0, scale: 1, ease: "expo.out", duration: 3 }
// );

// import Swiper from "swiper";

import {
  getPromoSwiper,
  homeproductSwiper,
  globalPageSwiper,
  projectPageSwiper,
  thumbnailPageSwiper,
} from "./components/allSwiper";
import { getNavigation } from "./components/navigation";
import { menuTab } from "./components/menuTab";
import { getProducts } from "./components/getProducts";

// window.addEventListener("load", (event) => {
//   console.log("page is fully loaded");
// });

// AOS.init();

getNavigation();
const rootElement = document.getElementById("root");
if (rootElement) {
  getProducts();
}
/* check mobile */
var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const bodyEl = document.body;
if (isMobile) {
  bodyEl.classList.add("mobile");
} else {
  bodyEl.classList.add("desktop");
}
/* home page */
const promoSwiper = document.getElementById("promoSwiper");
if (promoSwiper) {
  getPromoSwiper();
  bodyEl.classList.add("homepage");
}
/* detail page */
globalPageSwiper();
homeproductSwiper();
thumbnailPageSwiper();
projectPageSwiper();

/* scroll pagination & list */

const tabNavElement = document.getElementById("pills-tabContent");
if (tabNavElement) {
  menuTab();
}

setTimeout(() => {
  AOS.init();
  // console.log("AOS Init");
}, 100);


var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl, {
    html: true
  });
})

// let scrollRef = 0;
// window.addEventListener("scroll", function () {
//   // scrollRef <= 10 ? scrollRef++ : AOS.refresh();
//   if (scrollRef <= 10) {
//     //AOS.refresh();
//     AOS.init();
//     scrollRef++;
//   }
// });
